import { Application } from "@hotwired/stimulus";
import { DialogController } from "../components/dialog/dialog-controller";
import { TypeAnimationController } from "../components/type-animation/type-animation";
import { SiteNavigationController } from "../components/site-navigation/site-navigation.stimulus.js";

main();

function main() {
  console.log("Main module started");
  const application = Application.start();

  DialogController.register(application);
  TypeAnimationController.register(application);
  SiteNavigationController.register(application);
}
